import React from 'react';
import { Link as RouterLink, LinkProps as RouterLinkProps } from 'react-router';

import MuiLink from '@material-ui/core/Link';

export interface LinkProps extends RouterLinkProps {}

/**
 * https://v3.material-ui.com/style/links/#third-party-routing-library
 *
 * @param param
 */
export const Link: React.FC<LinkProps> = ({ ...rest }) => (
  // @ts-ignore
  <MuiLink variant="inherit" color="inherit" component={RouterLink} {...rest} />
);
